/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Flex, Text, Form, Pane, Toast, Label, Content } from '@leverege/ui-elements';
import { Users, Auth } from '@leverege/api-redux';
import { Validator } from '@leverege/validator';
import { Config } from '@leverege/plugin';
import { TitleBar } from '@leverege/ui-plugin';
import I18N from '@leverege/i18n';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const screenIcon = 'https://storage.googleapis.com/molten-ui-assets/contact-title.png';
const {
  t
} = I18N.ns('molten.screens.account.ContactScreen');
class ContactScreen extends React.Component {
  static propTypes = {
    showHeader: PropTypes.bool
  };
  static defaultProps = {
    showHeader: true
  };
  constructor(props) {
    super(props);
    this.state = {
      key: Date.now()
    };
    this.validator = {
      fields: {
        phone: {
          active: true,
          submitValidator: (value, name, formValues) => {
            if (value == null || value === '') {
              return true;
            }
            return Validator.isPhone(value) || t('invalidPhone', 'Must use a valid phone number');
          }
        },
        email: {
          active: true,
          submitValidator: (value, name, formValues) => {
            if (value == null || value === '') {
              return true;
            }
            return Validator.isEmail(value) || t('invalidEmail', 'Must use a valid email address');
          }
        }
      }
    };
  }
  componentDidMount() {
    const {
      setTitle,
      setIcon
    } = this.props;
    if (setTitle) setTitle({
      data: t('title')
    });
    if (setIcon) setIcon({
      data: Config.get('ContactScreen', 'screenIcon', screenIcon)
    });
  }
  renderForm = validator => {
    const {
      users
    } = this.props;
    const {
      errorMsg
    } = validator.getData();
    let error;
    if (users.error) {
      error = users.statusMessage.message;
    }
    return /*#__PURE__*/_jsxs(Pane, {
      layout: "flex:colL",
      variant: "contentSection",
      style: {
        maxWidth: '704px'
      },
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "sectionTitle",
        children: t('sectionTitle')
      }), /*#__PURE__*/_jsx(Flex, {
        variant: "colL",
        children: /*#__PURE__*/_jsx(Text, {
          variant: "sectionBody|subtitle",
          children: t('disclaimer')
        })
      }), /*#__PURE__*/_jsxs(Flex, {
        variant: "colL",
        children: [/*#__PURE__*/_jsxs(Flex, {
          variant: "setting|colM",
          children: [/*#__PURE__*/_jsx(Label, {
            variant: "inputTitle|title",
            children: t('emailAddress')
          }), /*#__PURE__*/_jsx(Form.TextInput, {
            alwaysFireOnReturn: false,
            changeOnReturn: false,
            variant: "inputGrow",
            hint: t('emailHint'),
            name: "email"
          }), /*#__PURE__*/_jsx(Form.Error, {
            variant: "inputCaptionSmallError",
            name: "email"
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "setting|colM",
          children: [/*#__PURE__*/_jsx(Label, {
            variant: "inputTitle|title",
            children: t('phoneNumber')
          }), /*#__PURE__*/_jsx(Form.TextInput, {
            alwaysFireOnReturn: false,
            changeOnReturn: false,
            variant: "inputGrow",
            hint: t('phoneHint'),
            name: "phone"
          }), /*#__PURE__*/_jsx(Form.Error, {
            variant: "inputCaptionSmallError",
            name: "phone"
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "rowSpaceBetween",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "errorText",
            children: errorMsg || error
          }), /*#__PURE__*/_jsxs(Flex, {
            variant: "rowM",
            children: [/*#__PURE__*/_jsx(Form.Revert, {
              variant: "secondary",
              children: t('cancel')
            }), /*#__PURE__*/_jsx(Form.Submit, {
              variant: "primary",
              onClick: this.saveChanges,
              children: t('submit')
            })]
          })]
        })]
      })]
    });
  };
  onSubmit = async values => {
    const {
      email,
      phone
    } = values.value;
    const {
      auth,
      dispatch
    } = this.props;
    try {
      await dispatch(Users.update(auth.profile.id, {
        email,
        phone
      }));
      await dispatch(Auth.renew());
      this.setState({
        key: Date.now()
      });
      Toast.success(t('toastSuccess'));
    } catch (ex) {
      Toast.error(t('toastError'));
    }
  };
  render() {
    const {
      auth,
      showHeader
    } = this.props;
    const {
      email = '',
      phone = ''
    } = auth.profile;
    const {
      key
    } = this.state;
    return /*#__PURE__*/_jsxs(Content, {
      children: [showHeader ? /*#__PURE__*/_jsx(Content.Header, {
        children: /*#__PURE__*/_jsx(TitleBar, {
          variant: "screenTitle",
          title: t('title'),
          icon: Config.get('ContactScreen', 'screenIcon', screenIcon)
        })
      }) : null, /*#__PURE__*/_jsx(Content.Area, {
        variant: "screenContent",
        children: /*#__PURE__*/_jsx(Form, {
          validator: this.validator,
          onSubmit: this.onSubmit,
          render: this.renderForm,
          data: {
            email,
            phone
          }
        }, key)
      })]
    });
  }
}
export default connect(state => ({
  auth: state.auth,
  users: state.users
}))(ContactScreen);